import React from 'react';
import { Input, FormControl } from '@material-ui/core';
import PropTypes from 'prop-types';
import useStyles from 'components/ui/TextInput/style';
import InputMask from 'react-input-mask';

const TextInput = (props) => {
  const classes = useStyles();
  const { name, type, label, disabled, value, mask, error } = props;

  return (
    <FormControl
      className={classes.textField}
      disabled={disabled || false}
    >
      <label className={classes.fieldLabel}>{label}</label>
      {mask ? (
        <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-fullWidth MuiInput-fullWidth MuiInputBase-formControl MuiInput-formControl">
          <InputMask
            autoComplete="off"
            {...props}
            className={classes.MaskInput}
          />
        </div>
      ) : (
        <Input name={name} type={type} fullWidth value={value} />
      )}
      {error && <div className={classes.inpError}>{error}</div>}
    </FormControl>
  );
};

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  mask: PropTypes.string,
  error: PropTypes.string,
};

TextInput.defaultProps = {
  disabled: false,
  value: '',
  mask: '',
  error: '',
};

export default TextInput;
